import { SUPPLIER_LIST_FAIL, SUPPLIER_LIST_REQUEST, SUPPLIER_LIST_SUCCESS } from "../constats/supplier.constant";

export const supplierListReducer = (state={},action) => {
    switch (action.type) {
        case SUPPLIER_LIST_REQUEST:
            return {
                loading: true
            };
        case SUPPLIER_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        case SUPPLIER_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            }
        default:
            return state;
    }
} 